<template>
  <div>
    <div class="panel-body p-n">
      <div class="col-md-12">
        <svg
          id="eld-ev-o-graph-svg "
          class="eld-log-ev-graph"
          preserveAspectRatio="xMinYMin"
          viewBox="0 0 1570 220"
          xmlns="http://www.w3.org/2000/svg"
        >
          <Grid />
          <hourLabelsVue />
          <statusDurationVue
            v-if="all"
            :on="all.filter((x) => x.status === 'ON')"
            :dr="all.filter((x) => x.status === 'D')"
            :sb="all.filter((x) => x.status === 'SB')"
            :off="all.filter((x) => x.status === 'OFF')"
          />
          <statusLabelsVue v-if="all" :active="all[all.length - 1].status" />
          <g class="status-events" transform="translate(60, 40)">
            <g
              class="status-event relative"
              @mouseleave="hideTooltip($event, null)"
              @mouseover="showTooltip($event, log)"
              v-for="(log, i) in draws"
              :key="i"
            >
              <line
                class="horizontal"
                :x1="log.start"
                :x2="log.end"
                :y1="log.status"
                :y2="log.status"
              ></line>
              <line
                v-if="draws.length !== i + 1"
                class="vertical"
                :x1="log.end"
                :x2="log.end"
                :y1="log.status"
                :y2="draws[i + 1].status"
              ></line>
              <rect
                id="eld-ev-o:9"
                class="hit-area"
                :class="{ active: hover === log.id }"
                :x="log.start"
                y="10"
                :width="log.width"
                height="180"
              ></rect>
              <!-- <line class="horizontal" :x1="log.start" :x2="log.end - draws[1].end" y1="178" y2="178"
                                style="stroke: rgb(45, 10, 10);">
                            </line> -->
            </g>
          </g>
          <g id="tooltip-center" visibility="hidden">
            <rect
              id="tooltip-center-bg"
              x="0"
              y="0"
              width="200"
              height="50"
              rx="5"
              ry="5"
              class="tooltip-bg"
            />
            <text
              id="tooltip-center-text"
              x="50"
              y="20"
              text-anchor="middle"
              class="tooltip-text"
              v-if="activeLog"
            >
              {{
                new Date(activeLog.dur * 1000)
                  .toUTCString()
                  .match(/(\d\d:\d\d:\d\d)/)[0]
              }}
            </text>
          </g>
          <g id="tooltip-left" visibility="hidden">
            <rect
              id="tooltip-left-bg"
              x="0"
              y="0"
              width="200"
              height="50"
              rx="5"
              ry="5"
              class="tooltip-bg"
            />
            <text
              id="tooltip-left-text"
              x="50"
              y="20"
              text-anchor="middle"
              class="tooltip-text"
              v-if="activeLog"
            >
              {{ $dayjs(activeLog.cr_time).format("HH:mm A") }}
            </text>
          </g>
          <g id="tooltip-right" visibility="hidden">
            <rect
              id="tooltip-right-bg"
              x="0"
              y="0"
              width="200"
              height="50"
              rx="5"
              ry="5"
              class="tooltip-bg"
            />
            <text
              id="tooltip-right-text"
              x="50"
              y="20"
              text-anchor="middle"
              class="tooltip-text"
              v-if="activeLog"
            >
              {{ $dayjs(activeLog.finished_time).format("HH:mm A") }}
            </text>
          </g>
          <use class="front" xlink:href=""></use>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
// import '../assets/css/bundle.css'
import Grid from "./Grid.vue";
import hourLabelsVue from "./hourLabels.vue";
import statusDurationVue from "./statusDuration.vue";
import statusLabelsVue from "./statusLabels.vue";
export default {
  components: {
    Grid,
    hourLabelsVue,
    statusDurationVue,
    statusLabelsVue,
  },
  data() {
    return {
      i: 0,
      times: 0,
      hover: null,
      activeLog: {
        dur: 0,
      },
      ids: [],
    };
  },
  computed: {
    minutes() {
      if (this.i === 0) {
        return (this.times = this.timeConvert(this.all[this.i].dur));
      } else if (this.i > 0) {
        return (this.times =
          this.times + this.timeConvert(this.all[this.i].dur));
      }
    },
    draws() {
      return this.$store.state.event.draws;
    },
  },
  methods: {
    change(change) {
      this.$refs.bar;
    },
    changeHover(log) {
      (this.hover = log), this.$emit("active", log);
    },
    showTooltip(evt, log) {
      this.changeHover(log.id);
      this.activeLog = this.all.filter((x) => x.id == log.id)[0];
      // Center
      const tooltipGroup = document.getElementById("tooltip-center");
      const tooltipBg = document.getElementById("tooltip-center-bg");
      const tooltipText = document.getElementById("tooltip-center-text");
      // Left
      const tooltipLeft = document.getElementById("tooltip-left");
      const tooltipLeftBg = document.getElementById("tooltip-left-bg");
      const tooltipLeftText = document.getElementById("tooltip-left-text");
      // Right
      const tooltipRight = document.getElementById("tooltip-right");
      const tooltipRightBg = document.getElementById("tooltip-right-bg");
      const tooltipRightText = document.getElementById("tooltip-right-text");
      // Center
      const x = log.start + log.width / 2;
      const y = log.status + 20;

      tooltipGroup.setAttribute("transform", `translate(${x}, ${y})`);
      const bboxCenter = tooltipText.getBBox();
      tooltipBg.setAttribute("width", bboxCenter.width + 50);
      tooltipBg.setAttribute("height", bboxCenter.height + 15);
      tooltipGroup.setAttribute("visibility", "visible");
      //Left
      const xLeft = log.start + log.width / log.width - 15;
      const yLeft = log.status + 20;

      tooltipLeft.setAttribute("transform", `translate(${xLeft}, ${yLeft})`);
      const bboxLeft = tooltipLeftText.getBBox();
      tooltipLeftBg.setAttribute("width", bboxLeft.width + 50);
      tooltipLeftBg.setAttribute("height", bboxLeft.height + 15);
      tooltipLeft.setAttribute("visibility", "visible");

      //Right
      const xRight = log.start + log.width + 20;
      const yRight = log.status + 20;

      tooltipRight.setAttribute("transform", `translate(${xRight}, ${yRight})`);
      const bboxRight = tooltipRightText.getBBox();
      tooltipRightBg.setAttribute("width", bboxRight.width + 50);
      tooltipRightBg.setAttribute("height", bboxRight.height + 15);
      tooltipRight.setAttribute("visibility", "visible");
    },
    hideTooltip(evt, log) {
      this.changeHover(null);
      this.activeLog = {
        dur: 0,
      };
      const tooltipGroup = document.getElementById("tooltip-center");
      tooltipGroup.setAttribute("visibility", "hidden");
      const tooltipLeft = document.getElementById("tooltip-left");
      tooltipLeft.setAttribute("visibility", "hidden");
      const tooltipRight = document.getElementById("tooltip-right");
      tooltipRight.setAttribute("visibility", "hidden");
    },
  },
  props: ["all", "live", "action"],
  mounted() {
    // console.log(this.live, 'live');
  },
};
</script>
<style lang="css" scoped>
@import url("../../../../../assets/css/bundle.css");
.tooltip-bg {
  fill: #333;
  stroke: #000;
  stroke-width: 1px;
  opacity: 0.8;
  z-index: 999999 !important;
}

.tooltip-text {
  fill: #fff;
  font-size: 12px;
  font-weight: 600;
  font-family: Arial, sans-serif;
  pointer-events: none; /* Prevents tooltip from blocking mouse events */
}

.status-event {
  cursor: pointer; /* Changes cursor to pointer on hover */
}
</style>
